var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-box"},[_c('Header',{on:{"add":_vm.handleAdd}}),_c('Table',{ref:"table",on:{"edit":_vm.handleEdit}}),_c('Dialog',{attrs:{"dialogVisible":_vm.dialogVisible,"form":_vm.form,"type":_vm.type},on:{"close":function($event){_vm.dialogVisible = false},"getData":_vm.getData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }